// eslint-disable-next-line import/no-extraneous-dependencies
import * as amplitude from '@amplitude/analytics-browser';
import { EVENTS } from '@constants';
import {
  useDownloadAvatar,
  useOfflineModulesRoutesPrecaching,
  useSyncOfflineData,
} from '@hooks';
import { authSlice } from '@store';
import { node } from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { CookiesModal } from 'src/components/CookiesModal';
import { NoNetworkPopup } from 'src/components/NoNetworkPopup';
import { ToastPopup } from 'src/components/ToastPopup';
import i18n from 'src/i18n';

import { getQueryParamValue } from '../../helpers/query';

const ScreenWrapper = ({ children }) => {
  const dispatch = useDispatch();
  useDownloadAvatar();
  useSyncOfflineData();
  useOfflineModulesRoutesPrecaching();

  const screenName = useMemo(
    () =>
      !children?.type?.name?.includes('Template') ? children?.type?.name : null,
    [children?.type?.name]
  );

  useEffect(() => {
    const languageQueryParamValue = getQueryParamValue('lng');

    if (!languageQueryParamValue) {
      return;
    }

    const isLanguageSupported = ['en', 'ua'].includes(languageQueryParamValue);

    if (isLanguageSupported) {
      // Set language both in Redux and i18n
      i18n.changeLanguage(languageQueryParamValue);
      dispatch(authSlice.actions.setLanguage(languageQueryParamValue));
    }

    // Reset the URL to remove the language query parameter
    window.history.replaceState(null, '', window.location.pathname);
  }, []);

  useEffect(() => {
    if (screenName) {
      amplitude.track(EVENTS.screenVisited, { screen_name: screenName });
    }
  }, [screenName]);
  return (
    <>
      <NoNetworkPopup />
      {screenName && <CookiesModal />}
      <ToastPopup />
      {children}
    </>
  );
};

ScreenWrapper.propTypes = {
  children: node.isRequired,
};

export default ScreenWrapper;
